import { Articles } from "@r8er/components/marketing/articles";
import { Hero } from "@r8er/components/marketing/hero";
import { Layout } from "@r8er/components/marketing/layout";
import { Newsletter } from "@r8er/components/marketing/newsletter";
import { getAllArticles } from "@r8er/lib/cms";
import Head from "next/head";

export default function ArticlesIndex({ articles }) {
  return (
    <div>
      <Head>
        <title>News &amp; Blog - R8ER</title>
        <link rel="icon" href="/favicon.png" />
      </Head>

      <Layout>
        <Hero isSlim isTiny title="News &amp; Blog" img="/news-hero.png" />
        <Articles title="" articles={articles} />
        <Newsletter hasBlueDivider />
      </Layout>
    </div>
  );
}

export async function getStaticProps(context) {
  const blogArticles = await getAllArticles();

  return {
    props: {
      articles: blogArticles,
    },
  };
}
